// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__1Yvdu","message":"CookieConsent_message__yCLOO","cookieLink":"CookieConsent_cookieLink__2vZ9K","continueBtn":"CookieConsent_continueBtn__14E00"};